export const TOKEN_NAME: string = "learned-hands-web-token"

export const appInfo = {
    title: "Learned Hands",
    desc: "Get started tagging people’s legal issues",
    logo: "/img/logo.png"
}

export const messagesGlobal = {
    missingParameter: "Missing Parameter",
    itemNotFound: "Item could not found",
    userNotAuthorized: "You are not authorized to see this page"
}

export type ReturnType = {
    status: boolean,
    message?: string
}